<template>
  <modal
    ref="modal"
    variant="default"
    no-footer
    is-alert-dialog
    class="date-change-notification-modal"
    aria-labelled-by="date-change-notification-modal-title"
    @input="handleOpenModal"
    @close="handleCloseModal"
  >
    <template #default="{ activate }">
      <slot v-bind="{ activate }" />
    </template>
    <template #header>
      <h5
        id="date-change-notification-modal-title"
        class="date-change-notification-modal__title"
      >
        {{ tc('spaSoft.step1.dateChangeTitle') }}
      </h5>
    </template>
    <template #body="{ deactivate }">
      <div class="date-change-notification-modal__description">
        {{ tc('spaSoft.step1.dateChangeDescription') }}
      </div>
      <div class="date-change-notification-modal__ctas">
        <button
          class="button--primary black size-md primary"
          @click="handleConfirmClick(deactivate)"
          @keydown.space.prevent="handleConfirmClick(deactivate)"
          @keydown.enter.prevent="handleConfirmClick(deactivate)"
        >
          {{ tc('spaSoft.step1.dateChangeContinueCta') }}
        </button>
        <button
          class="button--secondary black size-md outlined"
          @click="handleCancelClick(deactivate)"
          @keydown.space.prevent="handleCancelClick(deactivate)"
          @keydown.enter.prevent="handleCancelClick(deactivate)"
        >
          {{ tc('spaSoft.step1.dateChangeCancelCta') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'DateChangeNotificationModal',
    data: () => ({
      newDate: null,
      oldDate: null,
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
    },
    methods: {
      handleCloseModal() {
        document.body.classList.remove('no-scroll')
      },
      handleOpenModal() {
        document.body.classList.add('no-scroll')
        this.$emit('activate')
      },
      showNotification(newDate, oldDate) {
        this.newDate = newDate
        this.oldDate = oldDate
        this.$refs.modal.activate(this)
      },
      handleCancelClick(deactivate) {
        this.$emit('update-date', this.oldDate)
        deactivate()
      },
      handleConfirmClick(deactivate) {
        this.$emit('update-date', this.newDate)
        deactivate()
      }
    }
  }
</script>
